import {normalIndustry, designSizeOptions} from './constants';

const designSizeControlParams = {
    indestryBaseSizeMap: {
        ...normalIndustry.reduce((acc, item) => {
            acc[item] = '16:9';
            return acc;
        }, {})
    },
    sizeControlOptions: designSizeOptions
};

const bastTagInfo = {
    name: '选择配方',
    list: [{
        required: true,
        showRequired: true,
        name: '性别',
        option: [
            {label: '女性', value: '女性', type: 'gender', checked: false},
            {label: '男性', value: '男性', type: 'gender', checked: false}
        ]
    }, {
        required: true,
        showRequired: true,
        name: '年龄',
        option: [
            {label: '青年', value: '青年', type: 'age', checked: false},
            {label: '中年', value: '中年', type: 'age', checked: false},
            {label: '老年', value: '老年', type: 'age', checked: false}
        ]
    }, {
        required: false,
        name: '颜色',
        option: [
            {label: '白色服装', value: '白色服装', type: 'color', checked: false},
            {label: '黑色服装', value: '黑色服装', type: 'color', checked: false},
            {label: '浅蓝服装', value: '浅蓝服装', type: 'color', checked: false},
            {label: '棕色服装', value: '棕色服装', type: 'color', checked: false}
        ]
    }, {
        required: false,
        name: '风格',
        option: [
            {label: '正装', value: '职业西装，内搭白色衬衫', type: 'style', checked: false},
            {label: '国风装', value: '新中式国风装', type: 'style', checked: false},
            {label: '休闲装', value: '日常生活休闲装，长袖T恤', type: 'style', checked: false}
        ]
    }]
};

export const intelFormConfig = [{
    name: 'coverPicture',
    placeholder: '',
    visible: true,
    type: 'coverPicture',
    canCutout: true,
    params: {
        imageTagInfo: [
            bastTagInfo,
            {
                name: '不用配方',
                list: [{
                    required: true,
                    noIcon: true,
                    name: '原图',
                    option: [{
                        label: '使用原图抠图IP', value: '使用原图抠图IP', checked: false, autoWidth: true
                    }]
                }]
            }
        ],
        videoTagInfo: [bastTagInfo]
    },
    rules: [
        {
            required: true,
            validator(rule, value) {
                const {type, videoValue, imageValue} = value;
                if (type === 'video') {
                    if (!videoValue.showChooseIp) {
                        return Promise.reject('请选择视频生成IP');
                    }
                    return Promise.resolve();
                }
                if (type === 'image') {
                    if (!imageValue.showChooseIp) {
                        return Promise.reject('请选择图片生成IP');
                    }
                    return Promise.resolve();
                }
              }
        }
    ]
}];

export const designFormConfig = [
    {
        name: 'templateGroup',
        label: '模板',
        placeholder: '',
        visible: true,
        type: 'templateGroup',
        params: {
            chooseMax: 6,
            hideFilter: true,
            templateTag: ['IP封面模板'],
            industryOptions: [
                {
                    value: '',
                    label: '全部行业'
                },
                {
                    value: '19',
                    label: '文娱传媒'
                },
                {
                    value: '1',
                    label: '医疗器械'
                },
                {
                    value: '5',
                    label: '教育培训'
                },
                {
                    value: '10',
                    label: '金融服务'
                },
                {
                    value: '8',
                    label: '生活服务'
                },
                {
                    value: '11',
                    label: '房产家居'
                },
                {
                    value: '4',
                    label: '整形美容'
                },
                {
                    value: '7',
                    label: '商务服务'
                },
                {
                    value: '17',
                    label: '旅游服务'
                },
                {
                    value: '9',
                    label: '商品交易'
                },
                {
                    value: '22',
                    label: '保健品/药品'
                },
                {
                    value: '34',
                    label: '直营电商'
                },
                {
                    value: '25',
                    label: '食品饮料'
                }
            ],
            ratioOptions: designSizeOptions,
            ...designSizeControlParams
        },
        rules: [
            {
                required: true,
                validator(rule, value) {
                    const {template: {chooseList}} = value;
                    if (!chooseList?.length) {
                        return Promise.reject('请选择模板');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'ipName',
        label: 'IP名称',
        placeholder: '请输入',
        type: 'textInput',
        visible: true,
        needClear: true,
        params: {
            strict: true,
            maxlength: 8
        }
    },
    {
        name: 'ipPosition',
        label: 'IP职位',
        placeholder: '请输入',
        type: 'textInput',
        visible: true,
        needClear: true,
        params: {
            strict: true,
            maxlength: 12
        }
    },
    {
        name: 'mainText',
        label: '主标题',
        placeholder: '请输入',
        type: 'textInput',
        visible: true,
        params: {
            strict: true,
            maxlength: 20
        }
    },
    {
        name: 'descText',
        label: '副标题',
        placeholder: '请输入',
        type: 'textInput',
        visible: true,
        params: {
            strict: true,
            maxlength: 20
        }
    },
    {
        name: 'buttonText',
        label: '按钮文案',
        placeholder: '请输入',
        type: 'textInput',
        visible: true,
        params: {
            strict: true,
            maxlength: 6
        }
    },
    {
        name: 'riskText',
        label: '风险提示语',
        placeholder: '请输入',
        type: 'textInput',
        visible: true,
        needClear: true,
        params: {
            strict: true,
            maxlength: 30
        }
    },
    {
        name: 'brandLogo',
        label: '品牌LOGO',
        placeholder: '',
        type: 'uploadImgCard',
        visible: true,
        canCutout: true,
        params: {
        }
    },
    {
        name: 'brandName',
        label: '品牌名',
        placeholder: '请输入',
        type: 'textInput',
        visible: false,
        needClear: true,
        params: {
            strict: true,
            maxlength: 12
        }
    }
];
